export default class ACLService {
  constructor(permissions) {
    // user permissions
    this.permissions = permissions;
  }

  /**
   * Logic untuk mengecek apakah user memiliki permission yg diberikan di parameter atau tidak.
   *
   * @param {string} name
   * @param {string} permission
   */
  hasPermission(name, permission) {
    const result = this.permissions.filter(
      item => item.name === name && item.permission === permission
    );
    return result.length > 0;
  }

  /**
   * Untuk mengecek apakah name & permission yang diberikan ada di permissions User.
   * @param {array} permissions
   */
  hasPermissions(permissions) {
    if (!permissions) return true;

    const result = permissions.filter(item =>
      this.hasPermission(item.name, item.permission)
    );
    return result.length > 0;
  }

  /**
   * Untuk mengecek parent menu. Apakah punya permissions dari children-nya atau tidak.
   *
   */
  checkParentPermissions(parentItem) {
    const { items: children } = parentItem;
    const filtered = children.filter(child => this.checkPermission(child));
    return filtered.length > 0;
  }

  /**
   * Logic untuk mengecek apakah object routing 'to' mempunyai permissions atau tidak.
   *
   * @param {object} to
   */
  checkRoutePermissions(to) {
    const { acl } = to.meta;

    if (!acl) return true;

    if (Array.isArray(acl) && acl.length < 1) return true;

    return this.hasPermissions(to.meta.acl || []);
  }

  /**
   * Untuk mengecek apakah menu item mempunyai permissions atau tidak.
   *
   * @param {object} item
   */
  checkPermission(item) {
    if (!item.acl || item.acl.length < 1) return true;

    return this.hasPermissions(item.acl);
  }
}
